import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { UpdatesPage } from "@/features/updates/UpdatesPage";

const search = z.object({
  tab: z.enum(["all", "sent", "scheduled", "draft"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/updates/")({
  validateSearch: search,
  component: () => <UpdatesPage search={Route.useSearch()} />,
});
